/* global google */
const gMap = document.querySelector('.map__init');
const mapPins = document.querySelectorAll('.map__pins-info');

function initialize(el, mapLat, mapLng, mapZoom) {
  const mapOptions = {
    zoom: Number(mapZoom),
    center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    styles: [{
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [{
        color: '#444444',
      }],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [{
        color: '#f2f2f2',
      }],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [{
        visibility: 'off',
      }],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [{
        saturation: -100,
      },
      {
        lightness: 45,
      },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [{
        visibility: 'simplified',
      }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{
        color: '#ffde00',
      }],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [{
        visibility: 'off',
      }],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [{
        visibility: 'off',
      }],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [{
        color: '#bcbcbc',
      },
      {
        visibility: 'on',
      },
      ],
    },
    ],
  };

  const map = new google.maps.Map(el, mapOptions);
  const infoWindow = new google.maps.InfoWindow({ disableAutoPan: true });

  mapPins.forEach((mapPin) => {
    const pinLat = mapPin.getAttribute('data-markerlat');
    const pinLng = mapPin.getAttribute('data-markerlng');
    const mapPinIcon = mapPin.getAttribute('data-marker');
    const mapCity = mapPin.getAttribute('data-city');
    const infoCard = document.querySelector(`.infowindow-wrapper.${mapCity}`);

    const marker = new google.maps.Marker({
      map,
      position: new google.maps.LatLng(pinLat, pinLng),
      icon: mapPinIcon,
    });

    marker.addListener('click', () => {
      infoWindow.setContent(infoCard.innerHTML);
      infoWindow.open(map, marker);
    });
  });
}

if (gMap) {
  const mapLat = gMap.getAttribute('data-lat');
  const mapLng = gMap.getAttribute('data-lng');
  const mapZoom = gMap.getAttribute('data-zoom');

  initialize(gMap, mapLat, mapLng, mapZoom);
}
